import { safeDefine } from "../../registration/safe-define.js";
import { ErrorDialogElement } from "../../ui/error-dialog/element.js";
//#region src/define/ui/error-dialog.ts
safeDefine(ErrorDialogElement);
//#endregion

//# sourceMappingURL=error-dialog.js.map